import { render, staticRenderFns } from "./admin-groups.vue?vue&type=template&id=30e2a3dd&scoped=true"
import script from "./admin-groups.vue?vue&type=script&lang=js"
export * from "./admin-groups.vue?vue&type=script&lang=js"
import style0 from "./admin-groups.vue?vue&type=style&index=0&id=30e2a3dd&prod&lang=scss&scoped=true"
import style1 from "./admin-groups.vue?vue&type=style&index=1&id=30e2a3dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e2a3dd",
  null
  
)

export default component.exports